import axios from "axios";
import json from "../data/expolist.json";
const { decorate, observable, action } = require("mobx");
class Expo {
  list = json;

  async getJson() {}
}

decorate(Expo, {
  list: observable,
  getJson: action,
});

const init = new Expo();
export default init;
